import { render, staticRenderFns } from "./uber-uns.vue?vue&type=template&id=19622996&scoped=true&"
import script from "./uber-uns.vue?vue&type=script&lang=js&"
export * from "./uber-uns.vue?vue&type=script&lang=js&"
import style0 from "./uber-uns.vue?vue&type=style&index=0&id=19622996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19622996",
  null
  
)

export default component.exports